import { Fragment } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import { useOrganization } from '@/pages/organizations/detail'
import ReportsController from '@/pages/organizations/detail/reports'
import { titleTagSuffix } from '@/common/constants'
import { Helmet } from '@/common/components/Helmet'
import { organizationDisplayName } from '@/common/classes/OrganizationUtils'

export const Route = createFileRoute(
  '/app/organizations/$organizationId/reports',
)({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { organization } = useOrganization()

  return (
    <Fragment>
      <Helmet>
        <title>
          Reports for {organizationDisplayName(organization)}
          {titleTagSuffix}
        </title>
        <meta property="og:title" content={`Reports for ${organizationDisplayName(organization)}`} />
      </Helmet>
      <ReportsController />
    </Fragment>
  )
}
